interface BrowserEnvironmentVariables {
  DOCKER: string;
  STORYBOOK: string;
  REACT_APP_API_URL: string;
  REACT_APP_HERE_API_KEY: string;
  REACT_APP_HERE_GEOCODE_URL: string;
  REACT_APP_HERE_AUTOCOMPLETE_URL: string;
  REACT_APP_HERE_REV_GEOCODE_URL: string;
  REACT_APP_INCIDENT_MESSAGE: string;
  REACT_APP_ENVIRONMENT: string;
  REACT_APP_FARO_URL: string;
  REACT_APP_IDENTITY_CLIENT_API_KEY: string;
  REACT_APP_IDENTITY_AUTH_DOMAIN: string;
  REACT_APP_IDENTITY_APPLICANT_TENANT: string;
  REACT_APP_IDENTITY_ADVOCATE_TENANT: string;
  REACT_APP_IDENTITY_BEAM_TENANT: string;
  REACT_APP_PUBLIC_POSTHOG_KEY: string;
  REACT_APP_PUBLIC_POSTHOG_HOST: string;
}

type DockerWindow = Window & { env: BrowserEnvironmentVariables };
declare let window: DockerWindow;

export default function env(): BrowserEnvironmentVariables | NodeJS.ProcessEnv {
  if (window?.env?.DOCKER === 'true') return window.env;
  return process.env;
}
